import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import Reducer from '../reducers';

// create a store that has redux-thunk middleware enabled
const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

export default function configureStore() {
  return createStoreWithMiddleware(Reducer);
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js